import instance from "@/services/api";

export const buildingSettingsAPI = {
  async getProjectTypes() {
    return await instance()
      .get("/project_list/project/type/")
      .then((res) => res?.data);
  },
  async getResidentials() {
    return await instance()
      .get("/project_list/common/residents/read/")
      .then((res) => res?.data);
  },
  async getEntrances(params) {
    return await instance()
      .get(`/project_list/common/entrances/read/`, { params })
      .then((res) => res?.data);
  },
  async getResidentEntrances(resident_id) {
    return await instance()
      .get(`/project_list/common/residents/${resident_id}/entrances/read/`)
      .then((res) => res?.data);
  },
  async getProjectList(params = {}) {
    return await instance()
      .get("/project_list/project/read/", { params })
      .then((res) => res?.data);
  },
  async copyFloorToProject(floor_map_id, body = {}) {
    return await instance()
      .post(`/project_list/floor_map/${floor_map_id}/copy_to_project/`, body)
      .then((res) => res?.data);
  },
  async getEntranceApartments(params = {}) {
    return await instance()
      .get("/project_list/flat/read/", { params })
      .then((res) => res?.data);
  },
  async getFloorSchema(params = {}) {
    return await instance()
      .get("/project_list/floor_params/read/", { params })
      .then((res) => res?.data);
  },
  async getObjectInfo(params = {}) {
    return await instance()
      .get("/project_list/floor_params/details/read/", { params })
      .then((res) => res?.data);
  },
  async getEntranceColors(params = {}) {
    return await instance()
      .get("/project_list/flat/colours/read/", { params })
      .then((res) => res?.data);
  },
  async getFloorLegendInfo(params = {}) {
    return await instance()
      .get("/project_list/floor_params/param_types/read/", { params })
      .then((res) => res?.data);
  },
  async getEntranceLegendInfo(params = {}) {
    return await instance()
      .get("/project_list/flat/param_types/read/", { params })
      .then((res) => res?.data);
  },
  async getFloorParamTypes() {
    return await instance()
      .get("/project_list/floor_params/param_types/all/read/")
      .then((res) => res?.data);
  },
  async getFloorParamFrames(params = {}) {
    return await instance()
      .get("/project_list/common/frames/read/", { params })
      .then((res) => res?.data);
  },
  async getFloorRooms(params = {}) {
    return await instance()
      .get("/project_list/common/rooms/read/", { params })
      .then((res) => res?.data);
  },
  async getFloorFlatRooms(params = {}) {
    return await instance()
      .get("/project_list/floor_params/rooms/read/", { params })
      .then((res) => res?.data);
  },
  async updateFloorParam(body = {}, params = {}) {
    return await instance()
      .put("/project_list/floor_params/update/", body, { params })
      .then((res) => res?.data);
  },
  async changeFloorGroup(body = {}, params = {}) {
    return await instance()
      .post("/project_list/flat/grouping/", body, { params })
      .then((res) => res?.data);
  },
  async duplicateFloorGroup(body = {}, params = {}) {
    return await instance()
      .post("/project_list/floor_params/duplicate/", body, { params })
      .then((res) => res?.data);
  },
  async duplicateFlatToFloors(body = {}, params = {}) {
    return await instance()
      .post("/project_list/floor_params/replacement/", body, { params })
      .then((res) => res?.data);
  },
  async getFloorMapInfo(floor_map_id) {
    return await instance()
      .get(`/project_list/floor_map/${floor_map_id}/get_info/`)
      .then((res) => res?.data);
  },
  async addFloorMap(body = {}, params = {}) {
    return await instance()
      .post("/project_list/floor_map/add/", body, {
        params,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => res?.data);
  },
  async editFloorMap(floor_map_id, body = {}, params = {}) {
    return await instance()
      .put(`/project_list/floor_map/${floor_map_id}/edit/`, body, {
        params,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => res?.data);
  },
  async updateFloorMapLine(body, params) {
    return await instance()
      .put(`/project_list/floor_params/details/update/`, body, { params })
      .then((res) => res?.data);
  },
  async deleteFloorMapLine(floor_param_id, params = {}) {
    return await instance()
      .delete(`/project_list/floor_params/${floor_param_id}/delete/`, {
        params,
      })
      .then((res) => res?.data);
  },
  async getBufferParams(params = {}) {
    return await instance()
      .get(`/project_list/floor_params/buffer/read/`, { params })
      .then((res) => res?.data);
  },
  async blockParamType(body, params = {}) {
    return await instance()
      .post(`/project_list/floor_params/param_types/block/`, body, { params })
      .then((res) => res?.data);
  },
  async getFloorMapErrors(floor_map_id) {
    return await instance()
      .get(`/project_list/floor_map/${floor_map_id}/check_error/`)
      .then((res) => res?.data);
  },
  async recalculateSmeta(body, params) {
    return await instance()
      .post("/project_list/flat/smeta/recalculate/", body, { params })
      .then((res) => res?.data);
  },
  async recalculateFloorValues(floor_map_id, params) {
    return await instance()
      .post(`/project_list/floor_map/${floor_map_id}/recalculate/`, { params })
      .then((res) => res?.data);
  },
  async getWorkSets(floor_map_id, params = {}) {
    return await instance()
      .get(`/project_list/floor_map/${floor_map_id}/work_sets/`, { params })
      .then((res) => res?.data);
  },
  async getWorkSetMaterials(floor_map_id, work_set_id, params = {}) {
    return await instance()
      .get(
        `/project_list/floor_map/${floor_map_id}/work_sets/${work_set_id}/materials/`,
        {
          params,
        }
      )
      .then((res) => res?.data);
  },
  async getWorkSetFloors(floor_map_id, work_set_id, params = {}) {
    return await instance()
      .get(
        `/project_list/floor_map/${floor_map_id}/work_sets/${work_set_id}/levels/`,
        {
          params,
        }
      )
      .then((res) => res?.data);
  },
  async changeMaterial(floor_map_id, work_set_id, body = {}) {
    return await instance()
      .post(
        `/project_list/floor_map/${floor_map_id}/work_sets/${work_set_id}/levels/`,
        body
      )
      .then((res) => res?.data);
  },
  async getPresetMaterialSets(params = {}) {
    return await instance()
      .get("/project_list/common/preset/sets/read/", { params })
      .then((res) => res?.data);
  },
  async getPresetMaterials(params = {}) {
    return await instance()
      .get("/project_list/common/preset/materials/read/", { params })
      .then((res) => res?.data);
  },
  async modifyFloorParamMaterials(floor_param_id, body = {}) {
    return await instance()
      .post(
        `/project_list/floor_params/${floor_param_id}/materials/modify/`,
        body
      )
      .then((res) => res?.data);
  },
  async deleteFloorParamMaterial(floor_param_id, floor_param_material_id) {
    return await instance()
      .delete(
        `/project_list/floor_params/${floor_param_id}/materials/${floor_param_material_id}/modify/`
      )
      .then((res) => res?.data);
  },
  async createFloorObject(body, params) {
    return await instance()
      .post(`/project_list/flat/floor/create/`, body, { params })
      .then((res) => res?.data);
  },
  async getRevitFloorList(params) {
    return await instance()
      .get(`/project_list/floor_params/buffer/revit_data/read/floor_list/`, { params })
      .then((res) => res?.data);
  },
  async getRevitData(params) {
    return await instance()
      .get(`/project_list/floor_params/buffer/revit_data/read/`, { params })
      .then((res) => res?.data);
  },
  async createSmetaVersion(body) {
    return await instance()
      .post("/project_list/flat/smeta/create_version/", body)
      .then((res) => res?.data);
  },
  async getAvrLockedWorks(params) {
    return await instance()
      .get("/project_list/flat/avr_locked_works/read/", { params })
      .then((res) => res?.data);
  },
  async getRecalculableWorks(params) {
    return await instance()
      .get("/project_list/flat/recalculable_works/read/", { params })
      .then((res) => res?.data);
  },
  async getEntranceFloorsMismatch(params) {
    return await instance()
      .get("/project_list/common/entrance_floors/mismatch/read/", { params })
      .then((res) => res?.data);
  },
  async checkFlatRelations(floor_flat_id) {
    return await instance()
      .get(`/project_list/flat/${floor_flat_id}/check_relations/`)
      .then((res) => res?.data);
  },
  async deleteFlat(floor_flat_id) {
    return await instance()
      .post(`/project_list/flat/${floor_flat_id}/delete/`)
      .then((res) => res?.data);
  },
  async getAllRooms() {
    return await instance()
      .get("/project_list/floor_params/rooms/all/read/")
      .then((res) => res?.data);
  },
  async createFloorFlatParamValue(body) {
    return await instance()
      .post("/project_list/floor_params/floor_flat_param_value/create/", body)
      .then((res) => res?.data);
  },
  async deleteFloorFlatParamValue(body) {
    return await instance()
      .post("/project_list/floor_params/floor_flat_param_value/delete/", body)
      .then((res) => res?.data);
  },
};
